import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import * as screenfull from 'screenfull';
import {Screenfull} from "screenfull";

@Directive({
  selector: '[appFullscreen]'
})
export class FullscreenDirective {
  @Input('appFullscreen') el:any;
  @Output() fullscreenToggle = new EventEmitter();
  @Output() fullscreenActive = new EventEmitter();
  @HostListener('click') onClick() {
    let sf = <Screenfull>screenfull;
    if (sf.isEnabled) {
      sf.on('change', () => {       
        if(sf.isFullscreen){
          this.fullscreenToggle.emit('enter');
        }
        else{
          this.fullscreenToggle.emit('exit');      
        }
    });
    sf.toggle(this.el!!).then(()=>{
      if(sf.isFullscreen){
        setTimeout(()=>{ this.fullscreenActive.emit('active')  }, 350)   
      }
    });
    }
  }

}
